import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const File = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '25',
    defaultHeight: '25',
    style,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 14 17'
    >
      <path
        d='M8.5 1V4C8.5 4.39782 8.65804 4.77936 8.93934 5.06066C9.22064 5.34196 9.60218 5.5 10 5.5H13M9.25 1H2.5C2.10218 1 1.72064 1.15804 1.43934 1.43934C1.15804 1.72064 1 2.10218 1 2.5V14.5C1 14.8978 1.15804 15.2794 1.43934 15.5607C1.72064 15.842 2.10218 16 2.5 16H11.5C11.8978 16 12.2794 15.842 12.5607 15.5607C12.842 15.2794 13 14.8978 13 14.5V4.75L9.25 1Z'
        stroke={primaryColorToUse}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
